import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { HttpClientModule } from '@angular/common/http';
import { EventService } from '../../services/event.service';
import { dateRangeValidator } from '../../validators/non-async-validators';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { EventModel } from '../../models/EventModel';
import { MainModel } from '../../../global/model/MainModel';
import { Router } from '@angular/router';
import { EventCodeValidator } from '../../../global/validators/eventCodeValidator';
import { restrictToTwoDecimals } from '../../../global/util/util';

@Component({
  selector: 'app-event-modal',
  standalone: true,
  imports: [
    DialogModule,
    CardModule,
    ReactiveFormsModule,
    CommonModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    CalendarModule,
    HttpClientModule,
    ToastModule
  ],
  providers: [
    MessageService
  ],
  templateUrl: './event-modal.component.html',
  styleUrls: ['./event-modal.component.scss']
})
export class EventModalComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() eventData: EventModel|undefined = new EventModel();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<void>();
  @Input() eventTypes: any[] = [];
  @Output() visibleChange = new EventEmitter<boolean>();

  eventForm!: FormGroup;
  @Input() campaignId: number = -1;

  constructor(
              private fb: FormBuilder,
              private eventService: EventService,
              private messageService: MessageService,
              private router: Router,
              private mainModel: MainModel
            ) {
      this.eventForm = this.fb.group({
        eventCode: [this.eventData?.EventCode, Validators.required],
        eventTypeId: [this.eventData?.EventTypeID, Validators.required],
        eventDescription: [this.eventData?.EventDescription],
        location: [this.eventData?.Location],
        campaignYear: [this.eventData?.CampaignYear, [Validators.pattern('^[0-9]{4}$')]], // Validates a 4-digit year
        eventBudget: [this.eventData?.EventBudget], // Removed validators that block decimals
        startDate: [this.eventData?.StartDate],
        endDate: [this.eventData?.EndDate],
      },
        { validators: dateRangeValidator });
        this.campaignId = mainModel.selectedCampaign()?.campaignId || -1;
  }

  ngOnInit(): void {
      this.eventForm = this.fb.group({
        eventCode: [this.eventData?.EventCode, Validators.required, EventCodeValidator.createValidator(this.eventService, this.mainModel)],
        eventTypeId: [this.eventData?.EventTypeID, Validators.required],
        eventDescription: [this.eventData?.EventDescription],
        location: [this.eventData?.Location],
        campaignYear: [!this.eventData?.CampaignYear || this.eventData?.CampaignYear === 0 ? "" : this.eventData?.CampaignYear, [Validators.pattern('^[0-9]{4}$')]], // Validates a 4-digit year
        eventBudget: [this.eventData?.EventBudget], // Removed validators that block decimals
        startDate: [this.eventData?.StartDate],
        endDate: [this.eventData?.EndDate],
      },
        { validators: dateRangeValidator });
  }

  
  // checkEventCode():void {
  //   this.eventService.validateEventCode( this.eventForm.get('eventCode')?.value, this.mainModel.selectedCampaign()?.campaignId || 0 ).subscribe(
  //     (data) => {
  //       console.debug(data)
  //     }
  //   );
  // }

  onDialogClose(): void {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.onCancel.emit();
      this.eventForm.reset(new EventModel());
  }

  ngOnChanges(): void {
    if (this.visible) {
      this.resetForm();
      if (this.eventData) {
        this.eventForm.patchValue(this.eventData);
      }
    }
  }

  resetForm(): void {
    if (this.eventData) {
      this.eventForm.patchValue(this.eventData);
    } else {
      this.eventForm.reset(new EventModel());
    }

  }

  saveEvent(): void {
    this.eventForm.markAllAsTouched();
    if (this.eventForm.valid) {
      const event = this.eventForm.value;
      if (this.eventData && this.eventData.EventID) {
        this.eventService.updateEvent(event).subscribe(() => {
          this.onSave.emit();
          setTimeout(() => this.visible = false, 2500)
        });
      } else {
        // Create new event
        const _id:number = this.campaignId === -1 ? this.mainModel.selectedCampaign()?.campaignId || -1 : this.campaignId ;
        this.eventService.createEvent(event, _id).subscribe( {
          next: (data: any) => {
            this.messageService.add({ severity: 'success', summary: 'Event', detail: 'Event added successfully!' });
            this.onSave.emit();
            setTimeout(() => this.visible = false, 2500);
          },
          error: (error: any) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while saving event.' });
          }
        });
      }
    }
  }

  onAmountInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = restrictToTwoDecimals(input.value);
    this.eventForm.get('eventBudget')?.setValue(input.value, { emitEvent: false });
  }

}
